export const calcPrecioPublicacion = (p) => Number(p.precio) * (1 + (Number(p.alicuota) || 0) / 100)

export const calcPrecioPedido = (p) =>
  (Array.isArray(p.pedidoItems) ? p.pedidoItems : []).reduce(
    (total, e) => total + e.precioUnitario * e.cantidad * (1 + (e.alicuota || 0) / 100),
    0
  )
